const capitalize = (value, firstOnly) => {
  const regex = firstOnly ? /[[A-zÀ-ÿ]\S*/ : /[[A-zÀ-ÿ]\S*/g

  return value
    .toLowerCase()
    .replace(regex, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
}

export default capitalize
